<template>
  <div>
    <v-container v-if="loading" class="fill-height">
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-progress-circular indeterminate />
        </v-col>
      </v-row>
    </v-container>

    <v-container
      v-else-if="trainingRegistration"
      class="fill-height button"
      :class="canShowFeedbackForm && outlined ? 'outlined' : ''"
    >
      <template v-if="canShowFeedbackForm">
        <!--feedback heading-->
        <v-row justify="center" align="center" class="pt-3">
          <v-col cols="auto">
            <span class="text-h4 font-weight-bold textLight-text">
              {{ $t("course.feedback") }}
            </span>
          </v-col>
        </v-row>

        <!--feedback questions-->
        <v-row
          v-for="(feedbackQuestionAnswer, index) in feedbackQuestionAnswers"
          :key="'feedbackQuestionAnswer-' + index"
          align="start"
        >
          <v-col cols="12">
            <v-card flat class="rounded-2">
              <div class="d-flex pa-4 body-1 textLight--text text-start">
                <span class="pe-4"> {{ index + 1 }}. </span>

                <div class="flex-grow-1 pe-7">
                  <p class="ma-0">
                    {{ getLocalisedValue(feedbackQuestionAnswer.question) }}
                  </p>

                  <v-textarea
                    v-if="feedbackQuestionAnswer.isDescriptive"
                    v-model="feedbackQuestionAnswer.givenDescriptiveAnswer"
                    auto-grow
                    background-color="transparent"
                    flat
                    full-width
                    hide-details="auto"
                    outlined
                    persistent-hint
                    row-height="24"
                    rows="5"
                    class="rounded-2 my-3"
                  />

                  <template v-else>
                    <!--feedback recommend rating-->
                    <v-row class="mt-12">
                      <v-col class="py-0">
                        <v-slider
                          v-model="feedbackQuestionAnswer.givenRating"
                          min="1"
                          max="10"
                          step="1"
                          ticks
                          thumb-label="always"
                          :tick-labels="tickLabels"
                          track-color="#28116666"
                        />
                      </v-col>
                    </v-row>

                    <v-row justify="center" align="center">
                      <v-col class="text-start py-0">
                        <span class="caption textLight--text">
                          👎{{ $t("course.certificate.notLikely") }}
                        </span>
                      </v-col>

                      <v-col class="text-end py-0">
                        <span class="caption textLight--text">
                          👍{{ $t("course.certificate.extremeLikely") }}
                        </span>
                      </v-col>
                    </v-row>
                  </template>

                  <!--                  <v-radio-group
                    v-else
                    v-model="feedbackQuestionAnswer.givenAnswerKey"
                    hide-details
                    class="pb-2"
                  >
                    <v-radio
                      v-for="(
                        feedbackQuestionAnswerChoice, index
                      ) in feedbackQuestionAnswer.choices"
                      :key="'feedbackQuestionAnswerChoice-' + index"
                      :label="
                        getLocalisedValue(feedbackQuestionAnswerChoice.value)
                      "
                      :value="index"
                      @click="
                        feedbackQuestionAnswer.givenAnswer =
                          feedbackQuestionAnswerChoice.value
                      "
                    />
                  </v-radio-group>-->
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!--feedback submit button-->
        <v-row justify="end" align="center">
          <v-col cols="auto">
            <v-btn
              depressed
              color="primary"
              min-width="120"
              class="subtitle-2 font-weight-medium rounded-2 white--text"
              :disabled="!canSubmitFeedbackForm"
              :loading="submittingFeedback"
              @click="updateTrainingRegistrationFeedback"
            >
              {{ $t("submit") }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-container>

    <v-container v-else class="fill-height">
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-btn
            depressed
            large
            :loading="loading"
            class="subtitle-1 text-capitalize rounded-2"
            @click="fetchTrainingRegistration"
          >
            <v-icon left small> mdi-replay </v-icon>

            {{ $t("retry") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar
      :value="snackbarError"
      @input="resetSnackbar"
      timeout="3000"
      color="error"
    >
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="resetSnackbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { doQuery } from "@/app/core-module/util/graphqlHelper";
import { updateTrainingRegistrationFeedback } from "@/app/course-module/methods/updateTrainingRegistrationFeedback";

export default {
  name: "CourseFeedbackForm",
  props: {
    trainingRegistrationId: {
      type: String,
      required: true,
    },
    trainingRegistrationData: Object,
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      snackbarError: false,
      snackbarErrorMessage: null,
      trainingRegistration: null,
      feedbackQuestionAnswers: null,
      submittingFeedback: false,
    };
  },
  computed: {
    canShowFeedbackForm() {
      return (
        this.trainingRegistration &&
        !this.trainingRegistration?.feedback &&
        this.trainingRegistration?.training?.feedback?.questionAnswers?.length
      );
    },
    canSubmitFeedbackForm() {
      return true;
      // return this.feedbackQuestionAnswers?.some(x => {
      //   return (
      //     x.givenAnswer?.length || x.givenDescriptiveAnswer?.trim()?.length
      //   );
      // });
    },
    tickLabels() {
      return [...Array(10).keys()].map(x => (x + 1).toString());
    },
  },
  created() {
    if (this.trainingRegistrationData) {
      this.trainingRegistration = this.trainingRegistrationData;
      this.setFeedbackQuestionAnswers();
    } else {
      this.fetchTrainingRegistration();
    }
  },
  methods: {
    resetSnackbar() {
      this.snackbarError = false;
      this.snackbarErrorMessage = null;
    },
    fetchTrainingRegistration() {
      if (this.loading) return;
      this.loading = true;

      doQuery({
        query: require("../api/query/getTrainingRegistration.gql"),
        variables: { id: this.trainingRegistrationId },
      }).then(response => {
        if (response?.data?.getTrainingRegistration) {
          this.trainingRegistration = response.data.getTrainingRegistration;
          this.setFeedbackQuestionAnswers();
        } else if (response?.error) {
          this.snackbarError = true;
        }

        this.loading = false;
      });
    },
    setFeedbackQuestionAnswers() {
      if (this.canShowFeedbackForm) {
        this.feedbackQuestionAnswers =
          this.trainingRegistration.training.feedback.questionAnswers
            ?.sort((a, b) => a.displayPosition - b.displayPosition)
            ?.map(x => {
              return {
                ...x,
                givenAnswer: [],
                givenRating: x.isDescriptive ? null : 10,
                givenDescriptiveAnswer: null,
              };
            });
      }
    },
    updateTrainingRegistrationFeedback() {
      if (this.submittingFeedback) return;
      this.submittingFeedback = true;

      updateTrainingRegistrationFeedback({
        id: this.trainingRegistrationId,
        input: {
          questionAnswers: this.feedbackQuestionAnswers.map(x => {
            return {
              questionId: x._id,
              question: x.question,
              choices: x.choices,
              givenAnswer: x.givenAnswer,
              givenRating: x.givenRating,
              givenDescriptiveAnswer: x.givenDescriptiveAnswer,
              isDescriptive: x.isDescriptive,
            };
          }),
        },
      }).then(response => {
        if (response.data) {
          this.trainingRegistration.feedback = response.data.feedback;
          this.$emit("onSuccess");
        } else if (response.error) {
          this.snackbarError = true;
          this.$emit("onError");
        }

        this.submittingFeedback = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped />
